export interface AuthState {
  isFetching: boolean;
  isLoggedIn: boolean;
  isInitialized: boolean;
  serverError: string[];
  errorMessages: string[];
  name: string;
  isAdmin: boolean;
}

export interface AuthAction {
  type: string;
  [key: string]: unknown;
}

export const initialState = (): AuthState => ({
  isFetching: false,
  isLoggedIn: false,
  isInitialized: false,
  serverError: [],
  errorMessages: [],
  name: '',
  isAdmin: false
});

export default function auth(state: AuthState = initialState(), action?: AuthAction): AuthState {
  if (!action) {
    return state;
  }
  switch (action.type) {
    case 'LOGGED_IN':
      return {
        ...state,
        isLoggedIn: true,
        isInitialized: true,
        errorMessages: [],
        name: action.name as string,
        isAdmin: action.isAdmin as boolean
      };
    case 'NOT_LOGGED_IN':
      return {
        ...state,
        isLoggedIn: false,
        isInitialized: true,
        errorMessages: (action.errorMessages as string[]) ?? [],
        isAdmin: false,
        name: ''
      };
    case 'LOGGED_IN_UPDATE':
      return { ...state, name: action.name as string, isAdmin: action.isAdmin as boolean };
    // Kept as an array. It used to be stored as `errorMessage.toString()`, so several
    // messages rendered as one comma-joined string.
    case 'SERVER_ERROR':
      return { ...state, serverError: (action.errorMessage as string[]) ?? [] };
    default:
      return state;
  }
}

export const getAuth = (state: { auth: AuthState }): AuthState => state.auth;
